import React from 'react';
import Styles from './ImagePlaceholder.module.scss';

type ImagePlaceholderProps = React.PropsWithChildren<{}>;

export const ImagePlaceholder: React.FC<ImagePlaceholderProps> = ({ children }) => {
  return <div className={Styles.ImagePlaceholder}>{children}</div>;
};
